// extracted by mini-css-extract-plugin
export var ctas = "#226355";
export var descContainer = "ImageDescriptionContainer-module--descContainer--f9QQk";
export var grayBackground = "#f6f8fb";
export var img = "ImageDescriptionContainer-module--img--uwXN0";
export var imgContainer = "ImageDescriptionContainer-module--imgContainer--GaXA9";